//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';
import { EventColorEnum } from './Enums';

export class ExternalCalendarFeedDisplayItem extends ItemBase {
    ID: string | null = null;
    Name: string | null = null;
    URL: string | null = null;
    Color: EventColorEnum = EventColorEnum.Beach;
    TeacherID: string | null = null;
    Teacher: TeacherNameDisplayItem | null = null;
    Enabled: boolean = false;
    CreatedDate: string = "1970-01-01T00:00:00";
    LastUpdatedDate: string = "1970-01-01T00:00:00";
    LastFetchedDate: string | null = null;
    LastFailureDate: string | null = null;
    LastSuccessDate: string | null = null;
    LastErrorMessage: string | null = null;

    constructor(initializer?: Partial<ExternalCalendarFeedDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ExternalCalendarFeedDisplayItem";
}
